import { ComponentProps, ReactNode } from "react"
import { Link } from "react-router-dom"
import Alert from "../Alert"

interface BannerProps {
  title?: ReactNode
  variant?: ComponentProps<typeof Alert>["variant"]
  /** Optional in-app link rendered after the message. */
  link?: { to: string; label: string }
  /** The message. */
  children: ReactNode
}

/**
 * Page-level notice shown above the routed content (mounted in WithDrawer).
 * Callers decide WHEN to show it and pass the message; this only lays out the
 * Alert with the layout padding and an optional link. Must render inside a
 * Router when `link` is given.
 */
export default function Banner({
  title,
  variant = "info",
  link,
  children,
}: BannerProps) {
  return (
    <div className="p-4">
      <Alert
        title={title}
        variant={variant}
        injectable={false}
        content={
          <div>
            <span>{children}</span>
            {link && (
              <>
                {" "}
                <Link
                  to={link.to}
                  className="text-blue-400 hover:text-blue-300 font-bold"
                >
                  {link.label}
                </Link>
              </>
            )}
          </div>
        }
      />
    </div>
  )
}
